import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { errMsg } from "@/lib/api";

export default function AuthCallback() {
  const { googleLogin } = useAuth();
  const nav = useNavigate();
  const location = useLocation();
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    const sid = new URLSearchParams(location.hash.slice(1)).get("session_id");
    googleLogin(sid)
      .then(() => nav("/", { replace: true }))
      .catch((e) => nav("/login", { replace: true, state: { error: errMsg(e) } }));
  }, [googleLogin, nav, location.hash]);

  return <div className="flex h-screen items-center justify-center label-eyebrow" data-testid="auth-callback">Google ile giriş yapılıyor…</div>;
}
